import {
  serverTimestamp,
  type DocumentSnapshot,
  type FieldValue,
} from 'firebase/firestore';
import type { ID } from '@shared/types';

export function fromSnapshot<T extends { id: ID }>(snap: DocumentSnapshot): T | null {
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() } as T;
}

export function buildBaseFields(userId: ID): {
  createdAt: FieldValue;
  updatedAt: FieldValue;
  createdBy: ID;
  updatedBy: ID;
  isDeleted: boolean;
} {
  return {
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    createdBy: userId,
    updatedBy: userId,
    isDeleted: false,
  };
}

export function buildUpdateFields(userId: ID): {
  updatedAt: FieldValue;
  updatedBy: ID;
} {
  return {
    updatedAt: serverTimestamp(),
    updatedBy: userId,
  };
}

export function stripUndefined<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  ) as Partial<T>;
}
